import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleColorIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.24 13.2896C25.24 12.3855 25.1589 11.5162 25.0082 10.6816H13V15.6136H19.8618C19.5663 17.2073 18.668 18.5577 17.3176 19.4618V22.6609H21.4382C23.8491 20.4412 25.24 17.1726 25.24 13.2896Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 25.7504C16.4425 25.7504 19.3286 24.6087 21.4382 22.6614L17.3176 19.4623C16.1759 20.2273 14.7154 20.6793 13 20.6793C9.67916 20.6793 6.86836 18.4365 5.86575 15.4229H1.60608V18.7263C3.70404 22.8932 8.01586 25.7504 13 25.7504Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.8658 15.4228C5.6108 14.6578 5.46592 13.8407 5.46592 13.0003C5.46592 12.16 5.6108 11.3428 5.8658 10.5778V7.27441H1.60614C0.742614 8.99567 0.25 10.9429 0.25 13.0003C0.25 15.0577 0.742614 17.005 1.60614 18.7263L5.8658 15.4228Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 5.32103C14.8719 5.32103 16.5526 5.96433 17.8739 7.22774L21.5309 3.5708C19.3228 1.51341 16.4367 0.25 13 0.25C8.01586 0.25 3.70404 3.10716 1.60608 7.2741L5.86574 10.5775C6.86836 7.56388 9.67916 5.32103 13 5.32103Z",
			fill: "#EA4335"
		})
	]
});
const ForwardRef = forwardRef(SvgGoogleColorIcon);
export { ForwardRef as ReactComponent };
